import { StationDtoSchema } from "@station/data/dto/station.dto";
import * as z from "zod";

const SpatialLevelBaseDtoSchema = z.object({
    id: z.number(),
    name: z.string().trim(),
    to_label: z.string().trim(),
    stations: z.array(StationDtoSchema),
});

type SpatialLevelBaseDto = z.output<typeof SpatialLevelBaseDtoSchema>;

/**
 * Recursive type, zod needs manual type definition due typescript limitations
 * @see https://github.com/colinhacks/zod#recursive-types
 */
export const SpatialLevelDto: z.ZodType<
    SpatialLevelBaseDto & { children?: SpatialLevelDto[] }
> = SpatialLevelBaseDtoSchema.extend({
    children: z.lazy(() => z.array(SpatialLevelDto)).optional(),
}).readonly();

export type SpatialLevelDto = z.output<typeof SpatialLevelDto>;

export const SpatialLevelsDtoSchema = z.array(SpatialLevelDto).readonly();
export type SpatialLevelsDto = z.output<typeof SpatialLevelsDtoSchema>;

export interface SpatialLevelUpdateBody {
    spatialLevel: {
        name: string;
    };
}
